﻿import { OutputField } from "@models/configurators/output-fields/output-field";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { eOutputFieldType } from "@models/enums";
import { ICadCustomPropertyField } from "@models/entity-models";
import { KboOutputField } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";

@KboOutputField(CToken.CadCustomPropertyField, eOutputFieldType.cadCustomProperty)
export class CadCustomPropertyField extends OutputField implements ICadCustomPropertyField {
    constructor(kom: KbObjectManager) {
        super(kom);
    }

    public value: string;
    public fieldName: string;
    public partName: string;
    public partFamilyName: string;
}
